import { lazy } from 'react';
import { withSuspenseFallback } from '../../../helpers/withSuspenseFallback';

const Reports = lazy(() => import('../pages/Reports'));
const Stores = lazy(() => import('../../../../pages/Stores/Stores'));

const baseRoute = '/ticket-system';

const ticketSystemRoutes = [
  {
    path: baseRoute,
    component: withSuspenseFallback(Reports)
  },
  {
    path: `${baseRoute}/stores`,
    component: withSuspenseFallback(Stores)
  }
];

export default ticketSystemRoutes;